// extracted by mini-css-extract-plugin
export default {"faq":"Blog_faq__2dH1M","blogList":"Blog_blogList__nXn-R","blogItem":"Blog_blogItem__L38Zg"};